// ===== Easy Sell Badge - Safe Injector =====
// Only runs on product pages, never triggers form open
document.addEventListener('DOMContentLoaded', function() {

  // Only run on product pages
  if (!document.body.classList.contains('template-product')) return;

  function injectBadge() {
    var selectors = [
      'easysell-app',
      '[class*="easysell"]',
      '[id*="easysell"]',
      '[class*="easy-sell"]',
      '[id*="easy-sell"]'
    ];

    selectors.forEach(function(sel) {
      var els = document.querySelectorAll(sel);
      els.forEach(function(el) {
        if (el.closest('.sportivedz-badge-wrapper')) return;
        if (el.dataset.badgeInjected) return;

        var wrapper = document.createElement('div');
        wrapper.className = 'sportivedz-badge-wrapper';
        // Insert wrapper WITHOUT touching form state
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
        el.dataset.badgeInjected = 'true';
      });
    });
  }

  // Wait for Easy Sell to load, then inject badge only
  setTimeout(injectBadge, 800);
  setTimeout(injectBadge, 2000);
});
